import { render, staticRenderFns } from "./PricePlanEditModal.vue?vue&type=template&id=84d6c64e&scoped=true&"
import script from "./PricePlanEditModal.vue?vue&type=script&lang=js&"
export * from "./PricePlanEditModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PricePlanEditModal.vue?vue&type=style&index=1&id=84d6c64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d6c64e",
  null
  
)

export default component.exports